import { httpClient } from '../config';

export const rotateGoogleAdsBridgeSecret = async ({ id, industry_id }) => {
  // httpClient resolves with the error object on 4xx/5xx, so the secret must be checked explicitly
  const response = await httpClient(`/tables/google_ads_bridges/${id}/secret`, {
    method: 'POST',
    body: JSON.stringify({ industry_id }),
  });
  if (!response || !response.json || !response.json.secret) throw new Error('rotate failed');
  return response.json;
};

export const revealGoogleAdsBridgeSecret = async ({ id, industry_id }) => {
  // httpClient resolves with the error object on 4xx/5xx, so the secret must be checked explicitly
  const response = await httpClient(`/tables/google_ads_bridges/${id}/secret?industry_id=${industry_id}`);
  if (!response || !response.json || !response.json.secret) throw new Error('reveal failed');
  return response.json;
};
